import { useEffect, useState } from "react";

export const Section = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="mb-6">
    <h3 className="font-semibold mb-3">{title}</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">{children}</div>
  </div>
);

export const Info = ({
  label,
  value,
}: {
  label: string;
  value?: string | number;
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (value !== undefined && value !== null && value !== "") {
      setVisible(true);
    }
  }, [value]);

  return (
    <p className="text-sm flex gap-1">
      <b>{label}:</b>
      <span
        className={`transition-opacity duration-300 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
      >
        {value || "-"}
      </span>
    </p>
  );
};

export const Services = ({ services }: { services?: string[] }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (services?.length) {
      setVisible(true);
    }
  }, [services]);

  return (
    <ul
      className={`list-disc list-inside text-sm transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      {services?.map((s, i) => (
        <li key={i}>{s}</li>
      ))}
    </ul>
  );
};

export const Field = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex gap-3 items-start">
    <span className="font-semibold w-28 shrink-0">{label}:</span>
    {children}
  </div>
);

export const ReadOnly = ({
  label,
  value,
}: {
  label: string;
  value: string | string[];
}) => (
  <div className="flex gap-3 items-start">
    <span className="font-semibold w-28 shrink-0">{label}:</span>
    <span className="text-sm text-gray-600 dark:text-gray-400 break-all">
      {Array.isArray(value) ? value.join(", ") || "-" : value || "-"}
    </span>
  </div>
);

export const Input = ({
  label,
  value,
  onChange,
  error,
  type = "text",
}: any) => (
  <div>
    <label className="block text-sm font-medium">{label}</label>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="mt-1 w-full px-4 py-2 rounded-md shadow-sm bg-primaryBg dark:bg-primaryBgDark focus:outline-none focus:ring-0 focus:border-transparent
        [appearance:textfield]
        [&::-webkit-inner-spin-button]:appearance-none
        [&::-webkit-outer-spin-button]:appearance-none"
    />
    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);

export const Textarea = ({ label, value, onChange, error }: any) => (
  <div>
    <label className="block text-sm font-medium">{label}</label>
    <textarea
      rows={3}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="mt-1 w-full px-4 py-2 rounded-md shadow-sm bg-primaryBg dark:bg-primaryBgDark focus:outline-none focus:ring-0 focus:border-transparent resize-none"
    />
    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);
